import { render, staticRenderFns } from "./ReportSidebarAddNewCustomer.vue?vue&type=template&id=71cca61d&"
import script from "./ReportSidebarAddNewCustomer.vue?vue&type=script&lang=js&"
export * from "./ReportSidebarAddNewCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ReportSidebarAddNewCustomer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports